import React from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import { DATE_FORMAT, TIME_FORMAT } from '../constants';

/**
 * Data picker
 * Props:
 * value: number = unix timestamp
 * onChange: function: required => call back function. This function will be called in the
 *           onChange event of the component react-datetime with the parameter
 *           date.unix
 * isValidDate: function: is not required. this function is used to decide which
 *              dates are available to be choose.
 *              Example: don't allow to select dates higher than today
 *              static isValidDate(currentDate) {
 *               const today = Moment();
 *               return currentDate.isBefore(today);
 *             }
 */
export default class DatePicker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      value: props.value,
    };
  }

  /**
   * On change
   * @param moment value
   * @return unix timestamp date
   */
  onChange(value) {
    const { onChange } = this.props;
    this.setState({ value });
    onChange(value.unix());
  }

  render() {
    const { isValidDate } = this.props;
    const { value } = this.state;
    return (
      <Datetime
        value={value}
        onChange={this.onChange}
        dateFormat={DATE_FORMAT}
        timeFormat={TIME_FORMAT}
        input={false}
        open
        isValidDate={isValidDate}
      />
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  isValidDate: PropTypes.func,
};

DatePicker.defaultProps = {
  isValidDate: null,
};
